import type { Participant } from '@seen/core/models/patients/participant'
import { Button } from '@seen/ui'
import { IconDoorExit } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useModalStore } from '#src/hooks/useModalStore.ts'

interface CheckOutButtonProps {
  participant: Participant
  isDisabled?: boolean
}

export function CheckOutButton({
  participant,
  isDisabled = false,
}: CheckOutButtonProps): JSX.Element {
  const setCheckOutOpen = useModalStore((state) => state.setCheckOutOpen)
  const setParticipant = useModalStore((state) => state.setParticipant)

  const handleClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    e.preventDefault()
    setParticipant(participant)
    setCheckOutOpen(true)
  }

  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={handleClick}
      title="Check Out"
      disabled={isDisabled}
    >
      <IconDoorExit />
    </Button>
  )
}
